<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        id="close-modal-btn"
        data-cy="close-sort-filter-modal-button"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label class="filter-label-container" data-cy="filter-label">
      {{ 'i18n.sellerShowcasePage.filter' | translate }}
      <ion-badge data-cy="filter-qty-badge" class="green-badge" mode="ios">
        {{ selectedFilters?.size ?? 0 }}
      </ion-badge>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="seller-showcase-filter-content"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-desktop'
  "
>
  <ion-grid>
    <ion-row>
      <ion-col size="5" data-cy="seller-showcase-filter-options-col">
        <div class="seller-showcase-filter-options">
          <ion-item-divider></ion-item-divider>
          <app-highlighted-selectable-item
            [label]="'i18n.sellerShowcasePage.brand'"
            [selected]="selectedFilter === filterTypes.brand"
            [index]="0"
            [value]="selectedBrand"
            (clickValueEmitter)="setFilter(filterTypes.brand)"
          ></app-highlighted-selectable-item>
          <app-highlighted-selectable-item
            [label]="'i18n.sellerShowcasePage.promoType'"
            [selected]="selectedFilter === filterTypes.promoType"
            [index]="1"
            [value]="selectedPromoType"
            (clickValueEmitter)="setFilter(filterTypes.promoType)"
          ></app-highlighted-selectable-item>
          <app-highlighted-selectable-item
            [label]="'i18n.sellerShowcasePage.exclusiveBrands'"
            [selected]="selectedFilter === filterTypes.exclusiveBrand"
            [index]="2"
            [value]="selectedExclusiveBrand"
            (clickValueEmitter)="setFilter(filterTypes.exclusiveBrand)"
          ></app-highlighted-selectable-item>
          <app-highlighted-selectable-item
            [label]="'i18n.sellerShowcasePage.productClass'"
            [selected]="selectedFilter === filterTypes.productClass"
            [index]="3"
            [value]="selectedProductClass"
            (clickValueEmitter)="setFilter(filterTypes.productClass)"
          ></app-highlighted-selectable-item>
        </div>
      </ion-col>

      <ion-col size="7" data-cy="seller-showcase-filter-choices-col">
        <div class="seller-showcase-filter-choices">
          <ng-container *ngIf="selectedFilter === filterTypes.brand">
            <ion-radio-group
              (ionChange)="selectValue($event)"
              [(ngModel)]="selectedBrand"
              class="radio-options"
            >
              <ion-item>
                <ion-radio
                  slot="end"
                  justify="space-between"
                  mode="md"
                  [value]="filterValues.allSelected"
                  ><span class="seller-showcase-filter-choices-select-all">{{
                    'i18n.common.selectAll' | translate
                  }}</span></ion-radio
                >
              </ion-item>
              <ion-item *ngFor="let brand of brandsNames">
                <ion-radio justify="space-between" mode="md" [value]="brand">{{
                  brand | titlecase
                }}</ion-radio>
              </ion-item>
            </ion-radio-group>
          </ng-container>

          <ng-container *ngIf="selectedFilter === filterTypes.promoType">
            <ion-radio-group
              (ionChange)="selectValue($event)"
              [(ngModel)]="selectedPromoType"
              class="radio-options"
            >
              <ion-item>
                <ion-radio
                  slot="end"
                  justify="space-between"
                  mode="md"
                  [value]="filterValues.allSelected"
                  ><span class="seller-showcase-filter-choices-select-all">{{
                    'i18n.common.selectAll' | translate
                  }}</span></ion-radio
                >
              </ion-item>
              <ion-item *ngFor="let promoType of promoTypes">
                <ion-radio
                  justify="space-between"
                  mode="md"
                  [value]="promoType"
                  >{{ promoType | titlecase }}</ion-radio
                >
              </ion-item>
            </ion-radio-group>
          </ng-container>

          <ng-container *ngIf="selectedFilter === filterTypes.exclusiveBrand">
            <ion-radio-group
              (ionChange)="selectValue($event)"
              [(ngModel)]="selectedExclusiveBrand"
              class="radio-options"
            >
              <ion-item>
                <ion-radio
                  slot="end"
                  justify="space-between"
                  mode="md"
                  [value]="filterValues.allSelected"
                  ><span class="seller-showcase-filter-choices-select-all">{{
                    'i18n.common.selectAll' | translate
                  }}</span></ion-radio
                >
              </ion-item>
              <ion-item *ngFor="let exclusiveBrand of exclusiveBrandValues">
                <ion-radio
                  justify="space-between"
                  mode="md"
                  [value]="exclusiveBrand"
                  >{{ exclusiveBrand | titlecase }}</ion-radio
                >
              </ion-item>
            </ion-radio-group>
          </ng-container>

          <ng-container *ngIf="selectedFilter === filterTypes.productClass">
            <ion-radio-group
              (ionChange)="selectValue($event)"
              [(ngModel)]="selectedProductClass"
              class="radio-options"
            >
              <ion-item>
                <ion-radio
                  slot="end"
                  justify="space-between"
                  mode="md"
                  [value]="filterValues.allSelected"
                  ><span class="seller-showcase-filter-choices-select-all">{{
                    'i18n.common.selectAll' | translate
                  }}</span></ion-radio
                >
              </ion-item>
              <ion-item *ngFor="let productClass of productClasses">
                <ion-radio
                  justify="space-between"
                  mode="md"
                  [value]="productClass"
                  >{{ productClass | titlecase }}</ion-radio
                >
              </ion-item>
            </ion-radio-group>
          </ng-container>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="clear-all-modal-btn"
        data-cy="clear-all-sort-filter-modal-button"
        class="usf-outline-green-dsktp-tblt-modal-button"
        (click)="clearAll()"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </ion-button>
      <ion-button
        id="apply-modal-btn"
        data-cy="apply-sort-filter-modal-button"
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="applyAll()"
      >
        {{ 'i18n.common.apply' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
